<template>
 <div>
    <webHeader></webHeader>
    <div class="page">
        <div class="main">
            <el-table :data="tableDataList.slice((pageIndex-1)*15,pageIndex*15)" border style="max-width:1200px"  v-loading="isLoading" row-class-name="table-row" class="tablebox" stripe>
                <el-table-column label="序号" type="index" width="50" align="center" :index="indexMethod" fixed></el-table-column>
                <el-table-column label="托管机构" prop="custodianFullname" width="220px" :show-overflow-tooltip="true"  align="left" fixed>
                    <template slot-scope="scope">
                        <span v-if="scope.row.custodianFullname">{{scope.row.custodianFullname}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column label="托管资质时间"  width="110px" align="center">
                    <template slot-scope="scope">
                    <span>{{scope.row.applyDate ? formateDate(scope.row.applyDate):'--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="申请流程"  width="100px" align="center">
                    <template slot-scope="scope">
                    <span v-if="scope.row.applyProcess" class="link" @click="viewFile(scope.row.applyProcess,'申请流程')">预览&nbsp;&nbsp;</span>
                    <span v-if="scope.row.applyProcess" class="link" @click="downFile(scope.row.applyProcess, scope.row.custodianFullname, '申请流程')">下载</span>
                    <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column label="申请附件1"  width="100px" align="center">
                    <template slot-scope="scope">
                    <span v-if="scope.row.attachOne" class="link" @click="viewFile(scope.row.attachOne,'申请附件1')">预览&nbsp;&nbsp;</span>
                    <span v-if="scope.row.attachOne" class="link" @click="downFile(scope.row.attachOne, scope.row.custodianFullname, '附件1')">下载</span>
                    <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column label="申请附件2"  width="100px" align="center">
                    <template slot-scope="scope">
                    <span v-if="scope.row.attachTwo" class="link" @click="viewFile(scope.row.attachTwo,'申请附件2')">预览&nbsp;&nbsp;</span>
                    <span v-if="scope.row.attachTwo" class="link" @click="downFile(scope.row.attachTwo, scope.row.custodianFullname, '附件2')">下载</span>
                    <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column label="申请附件3"  width="110px" align="center">
                    <template slot-scope="scope">
                    <span v-if="scope.row.attachThree" class="link" @click="viewFile(scope.row.attachThree,'申请附件3')">预览&nbsp;&nbsp;</span>
                    <span v-if="scope.row.attachThree" class="link" @click="downFile(scope.row.attachThree, scope.row.custodianFullname, '附件3')">下载</span>
                    <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column label="邮箱"  width="180px" align="left">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.email">--</span>
                        <el-tooltip v-else placement="top">
                            <div slot="content" v-for="(item, index) in scope.row.email.split('，')" :key="index">{{item}}</div>
                            <div>
                                <div class="tooltipText" v-for="(item, index) in scope.row.email.split('，')" :key="index" v-show="index<=1">{{item}}</div>
                            </div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="联系人"  width="80px" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.name?scope.row.name:'--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="联系电话" align="left">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.phone">--</span>
                        <div  v-else v-for="(item, index) in scope.row.phone.split(', ')" :key="index">{{item}}</div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="bottom-pageFY">
                <p style="margin-top: 15px;" v-if="tableDataList.length>15">15条/页</p>
                <el-pagination v-if="tableDataList.length>15"  @current-change="pageChange" :current-page.sync="pageIndex" :page-size="15" layout="total, prev, pager, next" :total="tableDataList.length"></el-pagination>
                <!-- <v-pagination @page-change="pageChange" :total="tableDataList.length" :pageIndex="pageIndex" :page-size="15" :layout="['total', 'prev', 'pager', 'next', 'jumper']"> -->
                <!-- </v-pagination> -->
            </div>
        </div>
        <el-dialog
            title="文件预览"
            :visible.sync="isOpenXlsxDailog"
            :append-to-body="true"
            :close-on-click-modal="false"
            @close="isOpenXlsxDailog=false"
            custom-class="openXlsx"
            width="1100px"
            center>
            <div v-show="isOpenXlsxDailog" class="content">
                <iframe frameborder="0" :src="url" id="_iframe" width="100%" height="100%" ></iframe>
            </div>
        </el-dialog>
    </div>
    <webFooter></webFooter>
 </div>
</template>

<script>
import webHeader from "../components/webHeader";
import webFooter from "../components/webFooter";
import $ from 'jquery';
import layer from "layui-layer";
export default {
    name:'hffssWeb',
    data(){
        return{
            isOpenXlsxDailog: false,
            url: '',
            pageIndex: 1,
            isLoading: false,
            tableDataList: [],
            custodianFullname: '',
        }
    },
    components: {
        webFooter,
        webHeader,
    },
    mounted() {
        this.$nextTick(() => {
            this.getAjaxData();
        });
    },
    methods:{
        indexMethod(index) { //首页序号
            return (index+1)+(this.pageIndex-1)*15
        },
        pageChange(pageIndex) {
            this.pageIndex = pageIndex;
        },
        getAjaxData() {
            this.isLoading = true;
            this.$http.get(this.BASEURL+ "/raise-manager/product/apply/process?custodianFullname="+this.custodianFullname)
            .then((res) => {

                this.isLoading = false;
            if (res.data.status == 'success') {
                let array = this.productAsc(res.data.data, 'applyDate');

                //将有数据得排在最前面
                let array1 = [] 
                let array2 = [] 
                for (let index = 0; index < array.length; index++) {
                    const element = array[index];
                    if (element.applyProcess || element.attachOne || element.attachTwo || element.attachThree) {
                        array1.push(element)
                    }else {
                        array2.push(element)
                    }
                }
                console.log('this.tableDataLis',res.data);
                this.tableDataList.push(...array1)
                
            }
            }).catch(() => {
            })
        },
        viewFile(url,name) {
            console.log('url',url);
            
            if (url.slice(-4) == 'xlsx') {
                this.isOpenXlsxDailog = true
                this.url = 'https://view.officeapps.live.com/op/view.aspx?src='+url
            }
            else if (url.slice(-3).toLocaleLowerCase() === "doc" || url.slice(-4).toLocaleLowerCase() === "docx") {
                this.isOpenXlsxDailog = true
                this.url = "https://view.officeapps.live.com/op/view.aspx?src=" + url;
            }
            else {
                layer.open({
                    type: 2,
                    title: '预览',
                    area: [this.returnWandH().W, this.returnWandH().H],
                    closeBtn: 1,
                    maxmin: true,
                    resize: false,
                    moveOut: true,
                    shadeClose: false,
                    content: `http://www.pfile.com.cn/api/profile/onlinePreview?url=${encodeURIComponent(url)}`,
                    success: function () {
                        layer.close()
                    },
                    yes: function () {

                    },
                    end: function () {}
                })

                
            }
        },
        returnWandH() {
            return {
                W: "80%", // 使用窗口的宽度作为展示区域的宽度
                H: window.innerHeight + 'px' // 使用窗口的高度作为展示区域的高度
            };
        },
        downFile(url, custodianFullname, fileName) {
            if (url.slice(-3).toLocaleLowerCase() === "pdf") {
                this.downFileAjax(url,custodianFullname, fileName)
            }
            else {
                window.open(url)
            }
        },

      //下载文件
        downFileAjax(url, custodianFullname, fileName) {
            var xhr = new XMLHttpRequest();
            xhr.open("get", this.BASEURL+`/raise-common/download/downloadFile?name=${custodianFullname}的${fileName}&url=${url}`, true); // 也可以使用POST方式，根据接口
            xhr.withCredentials = true
            xhr.responseType = "blob"; // 返回类型blob
            xhr.onload = ()=>{
                var blob = new Blob([xhr.response],{type:'application/pdf'}),
                Temp = document.createElement("a")
                Temp.href = window.URL.createObjectURL(blob);
                Temp.download = `${custodianFullname}的${fileName}.pdf`//设置下载名
                $('body').append(Temp);
                Temp.click()
            }
            xhr.send()
        },
    }

}

</script>
<style scoped  type="text/scss" lang='scss'>
::v-deep .tablebox {
    margin: 0 auto; /* 设置左右外边距为 auto，使其水平居中 */
    th.el-table__cell{
        color: #333;
        font-weight: 700;
        font-size: 14px;
        height: 75px;
        padding: 8px 0;
        background: #dee6ff;
        border-top: 1px solid #f1f1f1;
        border-left: 1px solid #f1f1f1;
        border-bottom: 1px solid #f1f1f1;  
        text-align: center;
    }
    .el-table__cell{
        padding: 0 !important;
    }
    .column-content {
        height: 99px; /* 设置行高为99px */
        max-height: 99px; /* 设置最大高度 */
        overflow: hidden; /* 隐藏超出部分 */
        text-overflow: ellipsis; /* 显示省略号 */
        white-space: nowrap; /* 不换行 */
    }
    .table-row {
        height: 99px; /* 设置最大高度 */
        overflow: hidden; /* 隐藏超出部分 */
        text-overflow: ellipsis; /* 显示省略号 */
        white-space: nowrap; /* 不换行 */
    }
}
.page{
    margin-top: 100px;
}
::v-deep .openXlsx {
    height: 100%;
    margin: 0 auto!important;
    .el-dialog__body {
        height: calc(100% - 54px);
        .content {
        height: 100%;
        }
    }
}
.tooltipText{
    display: inline-block; /* 设置为块级元素，以便设置宽度和溢出 */
    max-width: 160px; /* 设置最大宽度为 180px */
    overflow: hidden; /* 隐藏超出部分 */
    text-overflow: ellipsis; /* 显示省略号 */
    white-space: nowrap; /* 不换行 */
}

</style>